import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Visible breadcrumb trail. `items` = [{ name, path }] including the current
 * page (last item is not linked). Home is prepended automatically.
 */
export default function Breadcrumbs({ items = [] }) {
  const trail = [{ name: "Home", path: "/" }, ...items];
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="wrap pt-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-[0.8rem] text-muted">
        {trail.map((it, i) => {
          const last = i === trail.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight size={13} className="text-line" aria-hidden="true" />}
              {last ? (
                <span className="text-ink font-medium" aria-current="page">{it.name}</span>
              ) : (
                <Link to={it.path} className="hover:text-blue transition-colors">{it.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
